/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import moment from 'moment';

const calculateOrgRequestBody = values => ({
  name: values.orgName,
  deactivationDate: values.deactivationDate ? moment(values.deactivationDate).utc().format() : null,
  notes: values.notes || null,
  orgType: values.orgType || null,
  permissions: {
    modelTypes: [
      ...(values.standard ? [1] : []),
      ...(values.advanced ? [2] : []),
      ...(values.siteHazards ? [3] : []),
    ],
    perRealization: values.allRealizations || false,
    recoveryTime: values.recoveryTime || false,
    extraction: values.extraction || false,
  },
});

export default calculateOrgRequestBody;
